import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "app/services/auth.service";

export const Logout = () => {
    const navigate = useNavigate();
    useEffect(()=>{
        logout();
        // window.location.href = "/login"; // works in React component and normal javascript functions
        navigate("/login"); // only works in React component
    }, [navigate]);
    return (
        <div>Logging out...</div>
    );
}